import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { UnitePathOptionCard } from './UnitePathOptionCard'

export type UniteShrinkPath = 'standard' | 'plus'

export interface UniteShrinkablePathPickerProps {
  path: UniteShrinkPath
  onPathChange: (path: UniteShrinkPath) => void
  isFreeUnite?: boolean
  uniteFee: number
  shrinkFee: number
}

export const UniteShrinkablePathPicker: FC<UniteShrinkablePathPickerProps> = ({ path, onPathChange, isFreeUnite, uniteFee, shrinkFee }) => {
  const { t } = useTranslation()

  const standardPrice = isFreeUnite ? t('unite.shrinkablePathStandardPriceFree') : t('unite.shrinkablePathStandardPricePaid', { uniteFee })

  const plusPrice = isFreeUnite
    ? t('unite.shrinkablePathPlusPriceFree', { shrinkFee })
    : t('unite.shrinkablePathPlusPricePaid', { uniteFee, shrinkFee })

  return (
    <div className='flex w-full flex-col items-center justify-center gap-6 md:flex-row md:items-start md:justify-center'>
      <UnitePathOptionCard
        selected={path === 'plus'}
        onSelect={() => onPathChange('plus')}
        title={t('unite.shrinkablePathPlusTitle')}
        featureTitle={t('unite.shrinkablePathPlusFeature')}
        featureSub={t('unite.shrinkablePathPlusSub')}
        priceLine={plusPrice}
      />
      <UnitePathOptionCard
        selected={path === 'standard'}
        onSelect={() => onPathChange('standard')}
        title={t('unite.shrinkablePathStandardTitle')}
        featureTitle={t('unite.shrinkablePathStandardFeature')}
        featureSub={t('unite.shrinkablePathStandardSub')}
        priceLine={standardPrice}
      />
    </div>
  )
}
